import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Hook condiviso: carica le categorie dal backend (GET /categories).
 * Rispetta i dati restituiti dall'API (nessun criterio inventato).
 * Errore gestito senza rompere il sito.
 */
export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/categories")
      .then(({ data }) => {
        if (!alive) return;
        const list = Array.isArray(data) ? data : (data?.categories || []);
        setCategories(list);
      })
      .catch(() => { if (alive) setCategories([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { categories, loading };
}

export default useCategories;
